import React from 'react'
import { Nav, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const NavItems = ({ title, items, link, userType }) => {
    const location = useLocation();
    if (items && items.length) {
        return (
            <NavDropdown title={title} id={`${title}-nav-dropdown`}>
                {items.map((item, index) => (
                    <NavDropdown.Item key={index} as={Link} to={item.path}>
                        {item.label}
                    </NavDropdown.Item>
                ))}
            </NavDropdown>
        );
    } else {
        return (
            <Nav.Link
                as={Link}
                to={link}
                className={location.pathname === `/${userType}/${link}` ? 'active-hnav' : ''}
            >
                {title}
            </Nav.Link>
        );
    }
}

export default NavItems;
